<template>
  <div class="index-statistik-sektoral">
    <div class="container">
      <SearchBanner/>
      <BannerSliders/>
      <!-- <DashboardStatistik/> -->
    </div>
    <BannerJaksurvei/>
    <div class="container">
      <SlideItems/>
    </div>
  </div>
</template>
  
<script>
import SearchBanner from '../../components/SearchBanner.vue'
import BannerSliders from '../../components/BannerSliders.vue'
// import DashboardStatistik from '../../components/DashboardStatistik.vue'
import BannerJaksurvei from '../../components/BannerJaksurvei.vue'
import SlideItems from '../../components/SlideItems.vue'
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'


export default {
  name: 'IndexStatistiksektoral',
  components:{
    SearchBanner,
    BannerSliders,
    // DashboardStatistik,
    BannerJaksurvei,
    SlideItems
  },
  data(){
    return{
    }
  },
  mounted(){
  },
  methods:{

  },
  setup() {
    
    const siteData = reactive({
      title: `Statistik Sektoral || Satudata Jakarta`,
      description: `Portal Satudata Jakarta Statistik Sektoral`,
      keyword:`satudata, jakarta, portal, statistik sektoral`,
      robots:`index, follow`,
      viewport:`width=device-width, initial-scale=1.0`,
      googlebot:`index, follow`,
      site_name:`Satudata Jakarta`,
      image:window.location.origin+'/img/logo-dark.96186bab.png',
      image_type:`image/jpeg`,
      url:window.location.href,
      type:`website`
    
    })
    
    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
            {
              name: `keywords`,
              content: computed(() => siteData.keyword),
            },
            {
              name: `description`,
              content: computed(() => siteData.description),
            },
            {
              name: `robots`,
              content: computed(() => siteData.robots),
            },  
            {
              name: `viewport`,
              content: computed(() => siteData.viewport),
            },
            {
              name: `googlebot`,
              content: computed(() => siteData.googlebot),
            },  
            {
              name: `og:site_name`,
              content: computed(() => siteData.site_name),
            },
            {
              name: `og:title`,
              content: computed(() => siteData.title),
            }, 
            {
              name: `og:description`,
              content: computed(() => siteData.description),
            }, 
            {
              name: `og:image`,
              content: computed(() => siteData.image),
            }, 
            {
              name: `og:image:type`,
              content: computed(() => siteData.image_type),
            }, 
            {
              name: `og:url`,
              content: computed(() => siteData.url),
            },
            {
              name: `type`,
              content: computed(() => siteData.type),
            },
      ],
      script: [
            { innerHTML: `var _paq = window._paq = window._paq || [];
              /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
              _paq.push(['trackPageView']);
              _paq.push(['enableLinkTracking']);
              (function() {
                var u="`+process.env.VUE_APP_MATOMO_URL+`"
                _paq.push(['setTrackerUrl', u+'matomo.php']);
                _paq.push(['setSiteId', `+process.env.VUE_APP_MATOMO_SITE_ID+`]);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
              })();` 
            }
      ]
    })


    



  }
}
</script>
  